import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.workpackage
        ? _c(
            VContainer,
            {
              attrs: {
                fluid: "",
                "pr-0": "",
                "pl-0": "",
                "pb-0": "",
                "pt-6": "",
              },
            },
            [
              _c(
                VRow,
                {
                  staticClass: "header text-row pl-4",
                  attrs: { "no-gutters": "" },
                },
                [
                  _c(VCol, { staticClass: "pb-0 pt-2" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("workPackages.owner")) + ": "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.workpackage.owner))]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                VRow,
                {
                  staticClass: "header text-row pl-4",
                  attrs: { "no-gutters": "" },
                },
                [
                  _c(VCol, { staticClass: "pb-0 pt-2" }, [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("workPackages.createdOn")) +
                          ":\n          "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.formatLocalisedDate(
                              _vm.workpackage.creationDate
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.workpackage.lastUpdated
                ? _c(
                    VRow,
                    {
                      staticClass: "header text-row pl-4",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(VCol, { staticClass: "pb-0 pt-2" }, [
                        _c(
                          "span",
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("workPackages.lastUpdated")) +
                                ":\n          "
                            ),
                            !_vm.isMasterWorkpackage
                              ? _c(
                                  "feature-toggle",
                                  {
                                    attrs: {
                                      toggle:
                                        "refreshWorkpackageFromDatabricks",
                                    },
                                  },
                                  [
                                    _vm.refreshing
                                      ? _c("progress-spinner", {
                                          attrs: {
                                            "job-id":
                                              _vm.workpackage.description,
                                            "job-type":
                                              "run_refresh_workpackage",
                                          },
                                        })
                                      : _c(
                                          VBtn,
                                          {
                                            staticClass: "refresh-btn",
                                            attrs: {
                                              "x-small": "",
                                              depressed: "",
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.isRefreshConfirmOpen = true
                                              },
                                            },
                                          },
                                          [_vm._m(0)],
                                          1
                                        ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("strong", [_vm._v(_vm._s(_vm.lastUpdatedText))]),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.workpackage.competitorLastUpdated && _vm.isMasterWorkpackage
                ? _c(
                    VRow,
                    {
                      staticClass: "header text-row pl-4",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(VCol, { staticClass: "pb-0 pt-2" }, [
                        _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("workPackages.competitorLastUpdated")
                              ) +
                              ":\n          "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.getFormattedDateTime(
                                  _vm.workpackage.competitorLastUpdated
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.workpackage.cumulativeProductCount && _vm.isMasterWorkpackage
                ? _c(
                    VRow,
                    {
                      staticClass: "header text-row pl-4",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(VCol, { staticClass: "pb-0 pt-2" }, [
                        _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("workPackages.documents")) +
                              "\n          "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("workPackages.documentsCount", {
                                  previousProductCount: _vm.formatNumber({
                                    number:
                                      _vm.workpackage.previousProductCount,
                                    format: _vm.numberFormats.integer,
                                  }),
                                  cumulativeProductCount: _vm.formatNumber({
                                    number:
                                      _vm.workpackage.cumulativeProductCount,
                                    format: _vm.numberFormats.integer,
                                  }),
                                })
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                VRow,
                { staticClass: "text-row pl-4", attrs: { "no-gutters": "" } },
                [
                  _vm.workpackage.releaseDate
                    ? _c(VCol, { staticClass: "pb-0 pt-2" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("workPackages.releaseDate")) +
                            ": "
                        ),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.workpackage.releaseDate)),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "feature-toggle",
                { attrs: { toggle: "enableAOExtracts" } },
                [
                  _vm.workpackage.aoExtracts &&
                  _vm.workpackage.aoExtracts.length > 0
                    ? [
                        _c(
                          VRow,
                          {
                            staticClass: "text-row pl-4",
                            attrs: { "no-gutters": "" },
                          },
                          [
                            _c(
                              VCol,
                              { staticClass: "pb-0 pt-2 ao-extracts" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("workPackages.aoExtracts")) +
                                      ":"
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.workpackage.aoExtracts, function (extract) {
                          return _c(
                            VRow,
                            {
                              key: extract.auditCorrelationId,
                              staticClass: "text-row pl-4",
                              attrs: { "no-gutters": "" },
                            },
                            [
                              _c(
                                VCol,
                                { staticClass: "pb-0 pt-2 ao-extracts" },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getAOExtractsByKey[
                                          extract.auditCorrelationId
                                        ].displayName
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "feature-toggle",
                          { attrs: { toggle: "usePeriodIdsInAOExtracts" } },
                          [
                            _c(
                              VRow,
                              {
                                staticClass: "text-row pl-4",
                                attrs: { "no-gutters": "" },
                              },
                              [
                                _c(
                                  VCol,
                                  { staticClass: "pb-0 pt-2 ao-extracts" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "workPackages.associatedPeriodIds"
                                          )
                                        ) + ":"
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.getWorkpackageAssociatedPeriodIds,
                              function (periodId) {
                                return _c(
                                  VRow,
                                  {
                                    key: periodId,
                                    staticClass: "text-row pl-4",
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c(
                                      VCol,
                                      { staticClass: "pb-0 pt-2 ao-extracts" },
                                      [_c("strong", [_vm._v(_vm._s(periodId))])]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.workpackage.missingProductsInAOExtracts
                          ? _c(
                              VRow,
                              {
                                staticClass: "text-row pl-4",
                                attrs: { "no-gutters": "" },
                              },
                              [
                                _c(
                                  VCol,
                                  { staticClass: "pb-0 pt-2" },
                                  [
                                    _c(
                                      VIcon,
                                      { attrs: { color: "orange darken-2" } },
                                      [_vm._v("warning")]
                                    ),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "workPackages.missingProductsInAOExtracts",
                                            {
                                              count:
                                                _vm.workpackage
                                                  .missingProductsInAOExtracts
                                                  .length,
                                            }
                                          )
                                        ) +
                                        "\n\n            "
                                    ),
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          text: "",
                                          outlined: "",
                                          small: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.isMissingProductsDialogOpen = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("actions.seeAll")) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("info-dialog", {
                                      attrs: {
                                        "is-open":
                                          _vm.isMissingProductsDialogOpen,
                                        "ok-btn-text": _vm.$t("actions.close"),
                                      },
                                      on: {
                                        onOk: function ($event) {
                                          _vm.isMissingProductsDialogOpen = false
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "header",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "workPackages.missingProductsInAOExtracts",
                                                        {
                                                          count:
                                                            _vm.workpackage
                                                              .missingProductsInAOExtracts
                                                              .length,
                                                        }
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "body",
                                            fn: function () {
                                              return [
                                                _c(
                                                  VExpansionPanels,
                                                  { attrs: { accordion: "" } },
                                                  _vm._l(
                                                    _vm.storeGroupsWithMissingProducts,
                                                    function (tsgKey) {
                                                      return _c(
                                                        VExpansionPanel,
                                                        { key: tsgKey },
                                                        [
                                                          _c(
                                                            VExpansionPanelHeader,
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .storegroupKeyNameMap[
                                                                      tsgKey
                                                                    ]
                                                                  ) +
                                                                  " -\n                      " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "workPackages.missingProductsInStoreGroup",
                                                                      {
                                                                        count:
                                                                          _vm
                                                                            .missingProductsInAOExtractsByTSGKey[
                                                                            tsgKey
                                                                          ]
                                                                            .length,
                                                                      }
                                                                    )
                                                                  ) +
                                                                  "\n                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            VExpansionPanelContent,
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    _vm.missingProductsInAOExtractsByTSGKey[
                                                                      tsgKey
                                                                    ].join(", ")
                                                                  ) +
                                                                  "\n                    "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3995529166
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _c(
            VContainer,
            {
              staticClass: "empty-reveal",
              attrs: { fluid: "", "pr-0": "", "pl-0": "", "pb-0": "" },
            },
            [
              _c(VRow, {
                staticClass: "header text-row",
                attrs: { "no-gutters": "" },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _c("incorrect-mappings-modal", {
        attrs: { "show-dialog": _vm.showIncorrectMappingsModal },
        on: { closeDialog: _vm.closeIncorrectMappingsModal },
      }),
      _vm._v(" "),
      _c("alert-dialog", {
        attrs: {
          "is-open": _vm.isRefreshConfirmOpen,
          "ok-btn-text": _vm.$t("actions.yesProceed"),
          "cancel-btn-text": _vm.$t("actions.cancel"),
        },
        on: {
          onOk: _vm.confirmRefresh,
          onCancel: function ($event) {
            _vm.isRefreshConfirmOpen = false
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _vm._v(_vm._s(_vm.$t("workPackages.refreshConfirm.header"))),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _vm._v(_vm._s(_vm.$t("workPackages.refreshConfirm.body"))),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(VIcon, [_vm._v("mdi-autorenew")])
  },
]
render._withStripped = true

export { render, staticRenderFns }